export type Locale = 'en' | 'fr';

export const LOCALES: Locale[] = ['en', 'fr'];

/**
 * Who a page is written for. A page is shown to the users whose permissions match its audience
 * (audiences.ts): the documentation follows what the user can do, as the rest of the viewer does.
 */
export type Audience =
  /** Anyone with a role: what the platform is, signing in, the home page. */
  | 'everyone'
  /** Whoever labels or reviews the tasks they are a member of: every role. */
  | 'labelling'
  /** Read-only links to a case or a pass: Reader, Corrector, Data Manager. */
  | 'reading'
  /** Correction mode: Corrector, Data Manager. */
  | 'correction'
  /** The backoffice and the platform's set-up: Data Manager. */
  | 'admin';

/** The two guides: the one for the people who read and annotate cases, and the data managers'. */
export type Guide = 'user' | 'admin';

/** A page's text in one language. `body` is Markdown; its `##` headings are the page's sections. */
export type DocText = {
  title: string;
  /** One line under the title, and in the search results. */
  summary: string;
  body: string;
};

export type DocPage = {
  /** The page's address: `/docs/<id>`. */
  id: string;
  guide: Guide;
  /** The heading the page is listed under in the navigation, by locale. */
  section: Record<Locale, string>;
  audience: Audience;
  text: Record<Locale, DocText>;
};
